export const PARAMETER_ID = {
  waterLevel: '532',
  // maxDepth: '533',
  manualDischarge: '531',
} // oracle

// export const PARAMETER_ID = {
//   waterLevel: 491,
//   // maxDepth: 492,
//   manualDischarge: 493,
// } // swh

// export const PARAMETER_ID = {
//   waterLevel: 274,
//   // maxDepth: 275,
//   manualDischarge: 276,
// } // alpha


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/config.js